(function($, Drupal) {

  Drupal.behaviors.flickity_menu = {
    attach: function (context, settings) {
      $('#tour-search-menu.carousel').flickity({
        cellAlign: "left",
        "freeScroll": true,
        "contain": true,
        "prevNextButtons": false,
        "pageDots": false
      })
    }
  }

  Drupal.behaviors.flickity_block = {
    attach: function (context, settings) {
      $('.carousel.block-area-menu').flickity({
        cellAlign: "left",
        "freeScroll": true,
        "contain": true,
        "prevNextButtons": false,
        "pageDots": true,
        "groupCells": true
      })
    }
  }

})(jQuery, Drupal);
